export enum Role {
  User = 'User',
  Moderator = 'Moderator',
  Admin = 'Admin',
}

export interface User {
  id: string;
  email: string;
  username: string;
  password: string;
  isConfirmed: boolean;
  activationCode: string | null;
  createdAt: Date;
  updatedAt: Date;
  avatarPath?: string;
  description?: string | null;
  role: Role;
}

export interface PublicUserProfile {
  username: string;
  avatarPath?: string | null;
  description?: string | null;
}

/**
 * AuthUser is a subset of User that is used for authentication. It is included in JWT tokens.
 */
export interface AuthUser {
  userId: string;
  username: string;
  avatarPath?: string;
  avatarUrl?: string;
  description?: string | null;
  role: Role;
}
